import { Link } from "react-router-dom";

type Crumb = { label: string; to?: string };
type Props = {
  eyebrow?: string;
  title: React.ReactNode;
  intro?: string;
  crumbs?: Crumb[];
};

export default function PageHeader({ eyebrow, title, intro, crumbs }: Props) {
  return (
    <section className="w-full pt-[112px] md:pt-[144px] pb-16 md:pb-24">
      <div className="w-full" style={{ paddingLeft: "clamp(20px, 5vw, 96px)", paddingRight: "clamp(20px, 5vw, 96px)" }}>
        {crumbs && crumbs.length > 0 && (
          <div className="flex items-center gap-2 text-[11px] tracking-[0.12em] uppercase text-ink-soft mb-8">
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-2">
                {c.to ? <Link to={c.to} className="hover:text-accent cursor-pointer">{c.label}</Link> : <span>{c.label}</span>}
                {i < crumbs.length - 1 && <span>/</span>}
              </span>
            ))}
          </div>
        )}
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h1 className="mt-5 font-serif-display font-light leading-[1.02]"
            style={{ fontSize: "clamp(38px,4vw,54px)", letterSpacing: "-0.02em", color: "#1D1A17" }}>
          {title}
        </h1>
        {intro && (
          <p className="mt-8 max-w-[640px] text-ink-soft leading-[1.65]" style={{ fontSize: "17px" }}>
            {intro}
          </p>
        )}
      </div>
    </section>
  );
}